import type { IForgotPasswordLocale } from '../../../../../Pages/Onboard/Forgot/Locale/ForgotPassword.locale';

const enUS: IForgotPasswordLocale = {
  title: 'Forgot your password?',
  subtitle:
    "Not a problem! Enter the email associated with your account and we'll send you a reset password link",
  email: {
    label: 'Email',
    placeholder: 'Enter your email address',
    error: 'Please enter a valid email address',
  },
  button: {
    sendLink: 'Send Reset Link',
    backToLogin: 'Back to Login',
    sendingLink: 'Sending...',
  },
  success: {
    title: 'Check your email',
    message:
      "We've sent a password reset link. Check your inbox and follow the instructions to reset your password.",
  },
};

export { enUS };
